import React from 'react';
import { Grid } from '@mui/material';

import useStyles from './styles';

interface IProps {
  labelSize: number;
  contentSize: number;
  component: React.ReactNode;
  label: string;
  hideLabel?: boolean;
}

const FieldWrapper: React.FC<IProps> = ({
  component: Component,
  labelSize = 12,
  contentSize = 12,
  label,
  hideLabel = false,
}) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      {!hideLabel && (
        <Grid item xs={labelSize} className={classes.label}>
          {label}
        </Grid>
      )}
      <Grid item xs={contentSize}>
        {Component}
      </Grid>
    </Grid>
  );
};

export default FieldWrapper;
